<template>
  <section class="input-field col" :class="size">
    <input :id="id"
           type="text"
           class="autocomplete"
           :disabled="disabled"
           :placeholder="watermark"
    >
    <label :id="`${id}-label`" class="active" :for="id">{{ name }}</label>
  </section>
</template>

<script>
export default {
  name: 'Autocomplete',
  components: {},
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
      validator(value) {
        return ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10', 's11', 's12'].includes(value);
      },
    },
    picks: {
      type: Array,
      required: true,
    },
    watermark: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    limit: {
      type: Number,
      required: false,
      default: 15,
    },
  },
  data() {
    return {};
  },
  computed: {
    mPicks() {
      const picksObj = {};
      this.picks.forEach(elem => {
        if (typeof elem === 'string' || typeof elem === 'number') {
          picksObj[elem] = null;
        } else {
          picksObj[elem.key] = elem.val;
        }
      });
      return picksObj;
    },
  },
  watch: {},
  methods: {},
  mounted() {
    const vm = this;
    const instance = this.materialize.Autocomplete.init(document.getElementById(this.id), {
      data: this.mPicks,
      limit: this.limit,
      minLength: 1,
      onAutocomplete(val) {
        const elem = this.$el[0];
        const choice = elem.value;
        vm.$emit('picked', choice, elem);
      },
    });
  },
};
</script>
